export default "__VITE_ASSET__WmN7PlgF__"